import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useStore = create(
  persist((set, get) => ({
    course: {
      id: "",
      name: "",
      type: "",
      heading: "",
      description: "",
      isAddedToStore: false,
      grades: [],
      subject: "",
      category: {},
      subCategory: "",
      coverPath: null,
      courseInstructor: {},
      catalogName: ""
    },
    book: {
      id: "",
      name: "",
      type: "",
      heading: "",
      description: "",
      isAddedToStore: false,
      grades: [],
      subject: "",
      category: {},
      subCategory: "",
      coverPath: null,
      bookPublisher: {},
      catalogName: ""
    },
    bookUploadProgress: [],
    courseUploadProgress: [],
    bookCurrentStep: 1,
    courseCurrentStep: 1,
    courseProgressLoading: false,
    bookProgressLoading: false,
    courseSelectedFilesFromGallery: [],
    bookSelectedFilesFromGallery: [],
    courseSelectedNewFiles: [],
    bookSelectedNewFiles: [],
    bookIsUploading: false,
    courseIsUploading: false,
    courseOutline: {},
    bookOutline: {},
    building: false,
    workingUUID: [],
    jobs: {},
    catalg: {},
    updateStates: (new_state) =>
      set((state) => ({
        ...state,
        ...new_state,
      })),
    resetStatesBook: () => {
      set(() => ({
        book: {
          id: "",
          name: "",
          type: "",
          heading: "",
          description: "",
          isAddedToStore: false,
          grades: [],
          subject: "",
          category: {},
          subCategory: "",
          coverPath: null,
          bookPublisher: {},
          catalogName: ""
        },
        bookCurrentStep: 1,
        bookProgressLoading: false,
        bookFilesToExtractText: [],
        bookSelectedFilesFromGallery: [],
        bookSelectedNewFiles: [],
        bookUploadProgress: [],
        bookIsUploading: false,
      }))
    },
    resetStatesCourse: () => {
      set(() => ({
        course: {
          id: "",
          name: "",
          type: "",
          heading: "",
          description: "",
          isAddedToStore: false,
          grades: [],
          subject: "",
          category: {},
          subCategory: "",
          coverPath: null,
          courseInstructor: {},
          catalogName: ""
        },
        courseCurrentStep: 1,
        courseProgressLoading: false,
        courseFilesToExtractText: [],
        courseSelectedFilesFromGallery: [],
        courseSelectedNewFiles: [],
        courseUploadProgress: [],
        courseIsUploading: false,
      }))
    },
    startJob: (jobKey, jobId) => {
      set(state => ({
        jobs: {
          ...state.jobs,
          [jobKey]: { jobId, status: 'processing' }
        }
      }));
    },
    updateJobStatus: (jobKey, status) => {
      set(state => ({
        jobs: {
          ...state.jobs,
          [jobKey]: {
            ...state.jobs[jobKey],
            status
          }
        }
      }));
    },
    removeJob: (jobKey) =>
      set((state) => {
        const newJobs = { ...state.jobs };
        delete newJobs[jobKey];
        return { jobs: newJobs };
      }),
    isJobInProgress: (jobKey) => {
      const job = get().jobs[jobKey];
      return job?.status === 'processing';
    },
    resetStates: () => {
      set((state) => ({
        ...state,
        course: {
          id: "",
          name: "",
          type: "",
          heading: "",
          description: "",
          isAddedToStore: false,
          grades: [],
          subject: "",
          category: {},
          subCategory: "",
          coverPath: null,
          courseInstructor: {},
          catalogName: ""
        },
        book: {
          id: "",
          name: "",
          type: "",
          heading: "",
          description: "",
          isAddedToStore: false,
          grades: [],
          subject: "",
          category: {},
          subCategory: "",
          coverPath: null,
          bookPublisher: {},
          catalogName: ""
        },
        bookCurrentStep: 1,
        courseCurrentStep: 1,
        courseProgressLoading: false,
        bookProgressLoading: false,
        courseFilesToExtractText: [],
        bookFilesToExtractText: [],
        courseSelectedFilesFromGallery: [],
        bookSelectedFilesFromGallery: [],
        courseSelectedNewFiles: [],
        bookSelectedNewFiles: [],
        courseUploadProgress: [],
        bookUploadProgress: [],
        bookIsUploading: false,
        courseIsUploading: false,
        building: false,
        jobs: {},
      }))
    }
  }),
    {
      name: 'appStates',
    }
  )
);
